import React from 'react';
import Creators from '@presentation/pages/Creators';
import ListLayout from '@presentation/layouts/ListLayout';

import { makeCreatorsService } from '../makeCreatorService';

const makeCreators = (firstPage: any) => {
	const creatorsService = makeCreatorsService();

	return (
		<ListLayout>
			<Creators firstPage={firstPage} creatorsService={creatorsService} />
		</ListLayout>
	);
};

export default makeCreators;
